<template>
  <div class="mb-4 text-lg font-semibold">
    <slot name="headline" />
  </div>
  <slot name="prefix" />
  <div :class="['mt-0 rounded-xl pt-1 pb-[1px] group', getBMargin(), bgClasses, extraClasses]">
    <slot />
  </div>
  <slot name="postfix" />
</template>


<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    props: {
      layout: {
        type: String,
        default: 'md',
      },
      bgClasses: {
        type: String,
        default: 'bg-white dark:bg-zinc-800/70',
      },
      extraClasses: {
        type: String,
        default: '',
      },
    },
    methods: {
      getBMargin() {
        if (this.layout == 'xs') return 'mb-2';
        if (this.layout == 'sm') return 'mb-4';

        return 'mb-8';
      },
    },
  })
</script>
